import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { createCurriculum, createMeal, deleteCurriculum, fetchAboutus, fetchCurriculumCategory, fetchCurriculumPlan, fetchPrivacyPolicy, fetchTermCondition, updateCurriculum, updateStatusCurriculum } from "../../../service/api";





export const getPrivacyPolicy = createAsyncThunk(
    "cms/getPolicy",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchPrivacyPolicy(params)
            console.log("policy", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getTermCondition = createAsyncThunk(
    "cms/getTerms",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchTermCondition(params)
            console.log("terms", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getAboutus = createAsyncThunk(
    "cms/getAbout",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchAboutus(params)
            console.log("about us", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


const cmsSlice = createSlice({
    name: "cms",
    initialState: {
        privacyPolicy: {},
        termCondition: {},
        aboutus: {},
        isLoading: false,
        error: null,

    },
    reducers: {},

    extraReducers: (builder) => {
        builder
            //PRIVACY
            .addCase(getPrivacyPolicy.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            .addCase(getPrivacyPolicy.fulfilled, (state, action) => {
                state.isLoading = false;
                state.privacyPolicy = action.payload.data;
            })

            .addCase(getPrivacyPolicy.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //TERMS
            .addCase(getTermCondition.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            .addCase(getTermCondition.fulfilled, (state, action) => {
                state.isLoading = false;
                state.termCondition = action.payload.data;
            })

            .addCase(getTermCondition.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //ABOUT
            .addCase(getAboutus.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            .addCase(getAboutus.fulfilled, (state, action) => {
                state.isLoading = false;
                state.aboutus = action.payload.data;
            })

            .addCase(getAboutus.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

    }
})


export default cmsSlice.reducer;
